export class RefundResubmitPostCommand{
    caseId:string;
    refundId:string;

    constructor(caseId:string, refundId:string){
        this.caseId = caseId;
        this.refundId = refundId;
    }
}